<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section about">
          <h3>关于我们</h3>
          <p>江苏智进科技有限公司成立于 2022 年，专注于电力自动化设备和物联网传感器研发的国家高新技术企业。公司以无源无线测温技术为核心，产品广泛应用于电力电缆、母线接头、高低压开关柜等关键设备的温度监测场景，为电力行业提供智能化、高可靠性的温度监测解决方案。</p>
          <div class="contact-info">
            <p><i class="fas fa-map-marker-alt"></i> {{companyInfo.address}}</p>
            <p><i class="fas fa-phone"></i> {{companyInfo.phone}}</p>
            <p><i class="fas fa-envelope"></i> {{companyInfo.email}}</p>
          </div>
        </div>
        <div class="footer-section links">
          <h3>快速链接</h3>
          <ul>
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/about">关于我们</router-link></li>
            <!-- <li><router-link to="/products">产品中心</router-link></li> -->
            <li><router-link to="/applications">场景应用</router-link></li>
            <!-- <li><router-link to="/join">加入我们</router-link></li> -->
            <!-- <li><router-link to="/news">新闻资讯</router-link></li> -->
          </ul>
        </div>
        <div class="footer-section qrcode">
          <!-- <h3>关注我们</h3>
          <div class="qrcode-container">
            <div class="qrcode-item">
              <img src="@/assets/images/2.png" alt="微信公众号">
              <p>微信公众号</p>
            </div>
            <div class="qrcode-item">
              <img src="@/assets/images/2.png" alt="官方微博">
              <p>官方微博</p>
            </div>
          </div> -->
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 版权所有：江苏智进科技有限公司 &nbsp;&nbsp;<img src="../assets/beiantubiao.jpg" style="position: relative; top: 4px;">&nbsp;
          <a href="https://beian.mps.gov.cn/#/query/webSearch" class="beian" target="_blank">苏公网安备 32128102010326号</a> <a href="https://beian.miit.gov.cn/"  target="_blank" class="beian">备案证书号 苏ICP备2023041494号.</a></p>
      </div>
    </div>
  </footer>
</template>


<script setup>
import { getCompanyInfo } from '@/utils/constant'
import { ref } from 'vue'
const handleImageError = (e) => {
  e.target.src = 'https://via.placeholder.com/120x120?text=二维码'
}
const companyInfo = ref({}) 
getCompanyInfo().then(res => {
  companyInfo.value = res
})
</script>

<style lang="scss" scoped>
.beian{
  // color: white;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    color: #3498db;
    transform: translateX(5px);
  }
}
.footer {
  background: #2c3e50;
  color: white;
  padding: 60px 0 20px;

  .footer-content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    margin-bottom: 40px;
  }

  .footer-section {
    h3 {
      font-size: 20px;
      margin-bottom: 20px;
      position: relative;
      padding-bottom: 10px;
      color: #3498db;

      &:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 40px;
        height: 2px;
        background-color: #3498db;
      }
    }

    &.about {
      p {
        margin-bottom: 20px;
        line-height: 1.6;
      }

      .contact-info {
        p {
          margin-bottom: 10px;
          display: flex;
          align-items: center;

          i {
            margin-right: 10px;
            color: #3498db;
          }
        }
      }
    }

    &.links {
      ul {
        list-style: none;
        padding: 0;

        li {
          margin-bottom: 10px;

          a {
            color: white;
            text-decoration: none;
            transition: all 0.3s ease;

            &:hover {
              color: #3498db;
              transform: translateX(5px);
            }
          }
        }
      }
    }

    &.qrcode {
      .qrcode-container {
        display: flex;
        gap: 20px;

        .qrcode-item {
          text-align: center;

          img {
            width: 120px;
            height: 120px;
            margin-bottom: 10px;
            border-radius: 8px;
            transition: all 0.3s ease;

            &:hover {
              transform: translateY(-5px);
              box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
            }
          }

          p {
            font-size: 14px;
          }
        }
      }
    }
  }

  .footer-bottom {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    p {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

@media (max-width: 768px) {
  .footer {
    .footer-content {
      grid-template-columns: 1fr;
      gap: 30px;
    }

    .footer-section.qrcode .qrcode-container {
      justify-content: center;
    }
  }
}
</style> 